import { i18n } from "@libs/i18n";

export const getStudentStatusBadgeVariant = (status: string) => {
  switch (status) {
    case "NOT_INVITED":
      return "outline";
    case "INVITED":
      return "secondary";
    case "INACTIVE":
      return "secondary";
    default:
      return "default";
  }
};

export const formatStudentStatus = (status: string) => {
  switch (status) {
    case "NOT_INVITED":
      return i18n.t(`main:students.status.notInvited`);
    case "INVITED":
      return i18n.t(`main:students.status.invited`);
    case "INACTIVE":
      return i18n.t(`main:students.status.inactive`);
    default:
      return i18n.t(`main:students.status.active`);
  }
};
